import '../index.scss';
import PropTypes from 'prop-types';
import React from 'react';

const Attachment = props => (
    <div className="basic-claim">
        <section className="claim-attachments">
            {props.attachments.map( attachment => (
                <div className="rows">
                    <a href={attachment.referenceUrl} target="_blank" rel="noopener noreferrer">
                        {attachment.fileName}
                    </a>
                </div>
            ) )
            }

        </section>
    </div>
);

Attachment.displayName = 'Attachment';
Attachment.propTypes = {
    attachments: PropTypes.array,
};

export default Attachment;
